import { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { themr } from '../react-css-themr'
import { TABS } from '../identifiers'

class TabContent extends Component {
  static propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    hidden: PropTypes.bool,
    theme: PropTypes.shape({
      active: PropTypes.string,
      tab: PropTypes.string,
    }),
  }

  render() {
    const { active = false, className = '', hidden = true, theme, children } = this.props
    const combinedClassName = cx(
      theme.tab,
      {
        [theme.active]: active,
      },
      className
    )

    return (
      <section className={combinedClassName} role='tabpanel' aria-expanded={hidden}>
        {children}
      </section>
    )
  }
}

export default themr(TABS)(TabContent)
export { TabContent }
